/**
 * @author: Michal Mlčoch <xmlcoc12@stud.fit.vutbr.cz>
 */

import {useEffect, useState} from "react";
import {Box, Grid, Alert, Divider, Chip, Collapse} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';

import AuctionFilter from "./AuctionsFilter";
import AuctionCard from "./AuctionCard";

import "./Auctions.css";
import {getFrom} from "../../data/api";

function Auctions() {
    const [open, setOpen] = useState(false);
    const [msgInfo, setMsgInfo] = useState("");
    const [showFilter, setShowFilter] = useState(true);

    const [auctions, setAuctions] = useState([]);
    const applyFilter = (filter) => {
        getFrom('/auctions', filter).then((res)=> {
            setAuctions(res.data);
            if (res.status !== 200){
                setMsgInfo({severity: "error", msg:"Nepodařilo se načíst aukce!"});
                setOpen(true);
            }
        }).catch((e)=>{
            setMsgInfo({severity: "error", msg:"Nepodařilo se načíst aukce!"});
            setOpen(true);
        })
    };

    useEffect(()=>{
        getFrom('/auctions').then((res)=>{
            setAuctions(res.data);
            if (res.status !== 200){
                setMsgInfo({severity: "error", msg:"Nepodařilo se načíst aukce!"});
                setOpen(true);
            }
        }).catch((e)=>{
            setMsgInfo({severity: "error", msg:"Nepodařilo se načíst aukce!"});
            setOpen(true);
        })
    },[])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };

    return (
        <Box sx={{ flexGrow: 1 }} className="site">

            <Snackbar 
                open={open} 
                autoHideDuration={5000} 
                onClose={handleClose}>
                <Alert onClose={handleClose} severity={msgInfo.severity} sx={{ width: '100%' }}>
                    {msgInfo.msg}
                </Alert>
            </Snackbar>

            <Collapse in={showFilter}>
                <AuctionFilter applyFilter={applyFilter} style={{hide:showFilter}}/>
            </Collapse>

            <Divider>
                <Chip
                    onClick={() => setShowFilter(!showFilter)}
                    label={showFilter ? "Skrýt filter" : "Zobrazit filter"}
                    />
            </Divider>

            <Box style={{marginTop: '15px'}}>
            <Grid container spacing={{ xs: 4, md: 3 }} columns={{ xs: 4, sm: 8, md: 12, lg: 16, xl: 20}}>
                {Array.from(auctions).map((auction, _) => (
                    <Grid item xs={4} sm={4} md={4} lg={4} lg={4} xl={4} key={auction.id}>
                        <AuctionCard auction={auction}/>
                    </Grid>
                ))}
            </Grid> 
            </Box>

        </Box>
    );
}


export default Auctions;